import React from "react"
import styles from "./intro.module.scss"

const LIST = [
  ["次世代游戏体验", "NEXT GENERATION GAMES"],
  ["未上市游戏试玩", "INDIVIDUAL GAMES"],
  ["参与金币挑战得奖品", "COIN CHALLENGE"],
  ["地狱难度游戏挑战赢大奖", "HELL CHALLENGE"],
  ["电竞速通激情上演", "SPEEDRUN"],
  ["多款独家场贩周边", "EXCLUSIVE MERCHANDISE"],
  [
    <>
      大型线上、线下实景互动冒险游戏
      <br />
      「弧光行动」
    </>,
    "ADVENTURE ROLEPLAY COMBINATION",
  ],
]

const Intro = () => {
  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <h1>
          <small>WHAT IS</small>
          G-FUSION
        </h1>
        <ul>
          {LIST.map(([zh, en], i) => {
            return (
              <li>
                <span>{i === LIST.length - 1 ? "NEW" : i + 1}</span>
                <div>
                  <span>{zh}</span>
                  <small>{en}</small>
                </div>
              </li>
            )
          })}
        </ul>
        <div className={styles.new}>
          <span>NEW</span>
          <p>
            大型线上、线下实景互动冒险游戏
            <br />
            「弧光行动」
          </p>
        </div>
      </div>
    </div>
  )
}

export default Intro
